"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnquiryDetailsListingDtoListingStatusEnum = exports.EnquiryDetailsListingDtoListingTypeEnum = void 0;
exports.instanceOfEnquiryDetailsListingDto = instanceOfEnquiryDetailsListingDto;
exports.EnquiryDetailsListingDtoFromJSON = EnquiryDetailsListingDtoFromJSON;
exports.EnquiryDetailsListingDtoFromJSONTyped = EnquiryDetailsListingDtoFromJSONTyped;
exports.EnquiryDetailsListingDtoToJSON = EnquiryDetailsListingDtoToJSON;
exports.EnquiryDetailsListingDtoToJSONTyped = EnquiryDetailsListingDtoToJSONTyped;
/**
 * @export
 */
exports.EnquiryDetailsListingDtoListingTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction',
    ReverseAuction: 'reverse_auction'
};
/**
 * @export
 */
exports.EnquiryDetailsListingDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * Check if a given object implements the EnquiryDetailsListingDto interface.
 */
function instanceOfEnquiryDetailsListingDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('listingType' in value) || value['listingType'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    return true;
}
function EnquiryDetailsListingDtoFromJSON(json) {
    return EnquiryDetailsListingDtoFromJSONTyped(json, false);
}
function EnquiryDetailsListingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'listingType': json['listingType'],
        'listingStatus': json['listingStatus'],
        'price': json['price'],
        'title': json['title'] == null ? undefined : json['title'],
        'displayAddress': json['displayAddress'] == null ? undefined : json['displayAddress'],
        'state': json['state'] == null ? undefined : json['state'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}
function EnquiryDetailsListingDtoToJSON(json) {
    return EnquiryDetailsListingDtoToJSONTyped(json, false);
}
function EnquiryDetailsListingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'listingType': value['listingType'],
        'listingStatus': value['listingStatus'],
        'price': value['price'],
        'title': value['title'],
        'displayAddress': value['displayAddress'],
        'state': value['state'],
        'updatedAt': value['updatedAt'],
    };
}
